<div class="layer2map">

  <!-- TopoMapControl builds the canvas + zoom toolbar inside this container -->
  <div class="layer2map-map-container"></div>

  <device-details #devicedetails [selectedDevice]="selectedDevice"></device-details>

  <link-details #linkdetails [selectedLinks]="selectedLinks" [version]="version"></link-details>

  <!-- triggerEvent="none" — opened programmatically via contextMenu.show(ev) -->
  <p-contextMenu #cm triggerEvent="none" [model]="items" appendTo="body"></p-contextMenu>

  <map-export [(display)]="exportVisible"
    [mode]="exportMode"
    [title]="exportTitle"
    (onExport)="onExport($event)"></map-export>

  <export-to-prtg-data-only [(display)]="exportToPrtgDataOnlyVisible"
    [netViewGuid]="exportToPrtgDataOnlyNetViewGuid"
    (onExport)="onExportToPrtgDataOnly($event)"></export-to-prtg-data-only>

  <export-to-prtg [(display)]="exportToPrtgVisible"
    [netViewGuid]="exportToPrtgNetViewGuid"
    [defaultExportName]="exportToPrtgDefaultName"
    (onExport)="onExportToPrtg($event)"></export-to-prtg>

  <export-to-prtg-map [(display)]="exportToPrtgMapVisible"
    [netViewGuid]="exportToPrtgMapNetViewGuid"
    [defaultMapName]="exportToPrtgMapDefaultName"
    (onExport)="onExportToPrtgMap($event)"></export-to-prtg-map>

  <!-- Lucid confirmation dialog -->
  <p-dialog [(visible)]="lucidConfirmVisible" (onHide)="displayLucidMap(false)" [modal]="true"
    [resizable]="false" appendTo="body">

    <p-header>
      <span>Your Lucidchart Map is Ready!</span>
    </p-header>

    <div>
      Click "OK" to view your Lucidchart map, or "Cancel" to discard it.
    </div>

    <p-footer>
      <button type="button" pButton icon="fa fa-check" (click)="displayLucidMap(true);" label="OK"></button>
      <button type="button" pButton icon="fa fa-close" (click)="displayLucidMap(false)" label="Cancel"></button>
    </p-footer>

  </p-dialog>

  <layout-settings-dialog [target]="layoutSettings" [(visible)]="layoutSettingsVisible"
    (onOk)="layoutMap()"></layout-settings-dialog>

  <map-search [(visible)]="mapSearchVisible" [map]="map" (deviceSelected)="onSearchDeviceSelected($event)"></map-search>

</div>


<!-- Offcanvas element for details -->
<ng-template #detailsOffCanvas let-offcanvas>
  <div class="offcanvas-header">
    <h4 class="offcanvas-title" id="offcanvas-basic-title">{{ selectedDevice ? 'Device' : 'Link' }} Details {{ selectedDevice ? ' - ' + selectedDevice.displayName : ''}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="onOffcanvasClose(); offcanvas.dismiss('Cross click')"></button>
  </div>
  <div class="offcanvas-body">
    <form>
      <div class="mb-3">
        <info-sets #infosets [selectedDevice]="selectedDevice"></info-sets>

        @if (selectedLinks.length > 0) {
          <link-details [selectedLinks]="selectedLinks" [version]="version"></link-details>
        }
      </div>
    </form>
  </div>
</ng-template>
